import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const usePrevision = () => {
    const { Token } = useUserSuperEmpresa();

     const getPrevision = async (params = {}) => {
    try {
      const { data } = await api.get("/previsiones", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

   const postPrevision = async (params = {}) => {
    try {
      const { data } = await api.post("/previsiones", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

   const eliminarPrevision = async (id) => {
    try {
      const { data } = await api.delete(`/previsiones/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };

   return { getPrevision,  postPrevision, eliminarPrevision };
}


export const useGetPrevision = () => {
  const { Token } = useUserSuperEmpresa();
  const {getPrevision } = usePrevision();
  const [Prevision, setPrevision] = useState([]);
  const [loadings, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPrevision = async () => {
    setLoading(true);
    try {
      const data = await getPrevision();
      setPrevision(data.data);
  
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoading(false);
    }
  };

  // Cargar al montar
  useEffect(() => {
    if (Token)fetchPrevision();
  }, [Token]);

  // ✅ Retorna la función refetch
  return { Prevision, loadings, error, refetch:fetchPrevision };
};